import { useEffect, useState } from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {status, STATUS_MODEL} from '../../../../../enums/statusEnum';
import {tryGetAddress} from "../../../../../Apis/functions";
import {chipStatusClassColor} from '../../../../../enums/statusColorEnum';
import {GetPublicEventDetail} from "../../../../../reduxToolkit/EmployeeEvents/EmployeeEventsApi";
/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const SuccessfullyRegisteredApp = () => {
    const navigate = useNavigate();
    const { eventId } = useParams();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { getPublicEventDetail } = useSelector((state) => state.EmployeeEventsSlice);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [monthDay, setMonthDay] = useState(null);
    const [latLng, setLatLng] = useState([]);
    const [chipStatus, setChipStatus] = useState(null);
    const [direction, setDirection] = useState(null);
    const statusId = getPublicEventDetail?.status?.id;

    /**
     * Gets the reservation data.
     */
    useEffect(() => {
        if(eventId){
            dispatch(GetPublicEventDetail(eventId));
        }
    }, [eventId]);


    useEffect(() => {
        if(statusId=== STATUS_MODEL.CANCELED){
            setChipStatus({name: "canceled_by_admin", className: "chip-error-code-150-100"});
        }else {
            setChipStatus({name: status[statusId], className: chipStatusClassColor[statusId] });
        }
    }, [getPublicEventDetail]);

    /**
     * Control of badge and follow-up card assignments according to the defined variables.
     * Assignment of the month and day label, assignment of latitude and longitude to a useState.
     */

    useEffect(() => {
        if (getPublicEventDetail?.id) {
            setMonthDay({ month: getMonth(getPublicEventDetail?.startDate), day: getDay(getPublicEventDetail?.startDate) });
        }
    }, [getPublicEventDetail]);



    /**
     * Function to assign the location obtained from the getLocation function to the variables latitude and longitude.
     */
    useEffect(() => {
        const latitude = getPublicEventDetail?.reservation?.zone?.latitud;
        const longitude = getPublicEventDetail?.reservation?.zone?.longitud;

        if (latitude && longitude) {
            getLocationData(latitude, longitude);
            setLatLng([latitude, longitude])
        }
    }, [getPublicEventDetail]);

    const getLocationData = (lat, lng) => {
        setDirection(t("loading"))
        tryGetAddress(lat, lng, dispatch, setDirection);
    }

    /**
     * Function to get the short month.
     */
    const getMonth = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString('es-ES', { month: 'short' });
    }

    /**
     * Function to get the day from a date.
     * @param timestamp
     * @returns {number}
     */
    const getDay = (timestamp) => {
        const date = new Date(timestamp);
        return date.getDate();
    }

    return {
        t,
        navigate,
        getPublicEventDetail,
        setLatitude,
        setLongitude,
        monthDay,
        latLng,
        direction,
        chipStatus
    }
}

export default SuccessfullyRegisteredApp
